import _ from 'lodash';
import api from '@/api';
import base64toPDF from '../../lib/base64ToPDF';
import Cookies from '@/portal-cookie';
import { message } from 'antd';
import paymentState from './paymentState';

const calculateCCFees = import.meta.env.VITE_USE_CC_FEES;

// console.log('calculateCCFees');
// console.log(calculateCCFees);

const initialState = {
	invoices: [],
	currentPaymentState: paymentState.NONE_SELECTED,
	showInvoicePaymentDialog: false,
	selectedForPayment: [],
	paymentErrors: [], // errors from authorize.net when attemping to capture payment
	invoicePaymentTotal: 0,
	cardPaymentFeesTotal: 0,
	processingErrors: [], // errors occured when writing to SAP w/ IncomingPayment doc
	successfulTransactionId: '', // this comes from authorize.net
	cardCode: '',
	cardType: '',
	cardName: '',
	loading: false,
	loaded: false,
	loadedVendorCode: false,
	acceptHostedToken: null,
	showPreviewPDFDialog: false,
	showContactDialog: false,
	pdfModalLoading: false,
	pdfModalData: null,
	pdfFilePreview: null,
	pdfModalKey: null,
	totalInvoiceDue: null,
	totalCredit: null,
	customerProfileId: null, // not being used anywhere yet
	customerProfileId_from_SAP: null,
	storePayment: true, // V1 WAS false
	responseCode: null,
	ccFeeExemptStates: [],
};

export const types = {
	SET_STATE: 'INVOICE/SET_STATE',
	SET_SELECTED: 'INVOICE/SET_SELECTED',
	UNSET_SELECTED: 'INVOICE/UNSET_SELECTED',
};

const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };

		case types.SET_SELECTED:
			return {
				...state,
				selectedForPayment: [
					...state.selectedForPayment,
					action.data,
				]
			};

		case types.UNSET_SELECTED:
			return {
				...state,
				selectedForPayment: state.selectedForPayment
					.filter((record) => record.DocEntry !== action.data.DocEntry)
					.map((record) => ({ ...record }))
			};
		default:
			return state;
	}
};

export default reducers;

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	resetContactDialog: () => ({
		type: types.SET_STATE, data: {
			showContactDialog: false,
		},
	}),

	resetInvoicePaymentDialog: () => ({
		type: types.SET_STATE, data: {
			currentPaymentState: paymentState.NONE_SELECTED,
			showInvoicePaymentDialog: false,
			//invoicePaymentTotal: 0, 	// NOTE V3 doesnt do this on reset because it would zero after closing modal, leading to authorize.net error
			cardPaymentFeesTotal: 0, 	// NOTE V3 its okay to reset this because it will be recalculated after payment type is chosen
			processingErrors: [],
			//selectedForPayment: [], 	// NOTE V3 not resetting here, but will reset after loadInvoices; which happens in the appropriate situations
			successfulTransactionId: '',
			acceptHostedToken: null,
		},
	}),

	resetInvoicePDFDialog: () => ({
		type: types.SET_STATE, data: {
			showInvoicePDFDialog: false,
		},
	}),

	reset: () => ({ type: types.SET_STATE, data: { ...initialState } }),

	setSelected: (record) => ({ type: types.SET_SELECTED, data: record }),

	unsetSelected: (record) => ({ type: types.UNSET_SELECTED, data: record }),

	loadInvoices: () => async (dispatch, getState) => {
		console.log('[Invoices.redux] loadInvoices');
		const state = getState(),
			loading = state.invoices.loading,
			cardCode = state.invoices.cardCode,
			cardType = state.invoices.cardType;

		//console.log(cardCode)
		//console.log(cardType)
		if (loading) {
			return false;
		}

		dispatch(actions.setState({ loading: true, loaded: false }));

		try {
			let response = await api.get('/invoices', {
				params: {
					cardCode,
					cardType
				},
			});

			const _invoices = response[0];
			//console.log(_invoices)

			const totalInvoiceDue = response[1][0]['DocTotalOpen'];
			const totalCredit = response[2][0]['DocTotalCredit'];
			// const invoices = response.map((invoice) => {
			// 	return { ...invoice, 'PayAmount': invoice.DocumentTotal };
			// });

			const cardNameProp = cardType === 'C' ? 'CustomerName' : 'VendorName';

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					invoices: _invoices,
					cardName: response[0].length > 0
						? response[0][0][cardNameProp]
						: '',
					totalInvoiceDue: totalInvoiceDue,
					totalCredit: totalCredit,
					currentPaymentState: paymentState.NONE_SELECTED,
					showInvoicePaymentDialog: false,
					selectedInvoices: []
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					invoices: [],
					cardName: '',
				},
			});
		}
	},

	loadVendorCode: () => async (dispatch) => {
		console.log('[Invoices.redux] loadVendorCode')
		try {
			const userKey = Cookies.get('TS_UserKey', '');
			const response = await api.get('/invoices/vendor-code', {
				params: {
					userKey: userKey,
				},
			});

			//console.log('CustomerProfileId');
			//console.log(response.CustomerProfileId);

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: response.BPCode,
					cardType: response.BPType,
					customerProfileId_from_SAP: response.CustomerProfileId,
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: '',
					cardType: '',
				},
			});
		}
	},

	loadCCFeeExemptStates: () => async (dispatch, getState) => {
		console.log('[Invoices.redux] loadCCFeeExemptStates');
		try {
			// QUERY CustomerPortal.GetCCFeeExemptStates
			const response = await api.get('customers/cc-fee-exempt-states');
			const ccFeeExemptStates = Array.isArray(response)
				? response
				: Array.isArray(response?.states)
					? response.states
					: [];

			if (_.isEqual(getState().invoices.ccFeeExemptStates, ccFeeExemptStates)) {
				return;
			}

			dispatch({
				type: types.SET_STATE,
				data: {
					ccFeeExemptStates,
				},
			});
		} catch (err) {
			console.error(err);
			if (getState().invoices.ccFeeExemptStates.length === 0) {
				return;
			}
			dispatch({
				type: types.SET_STATE,
				data: {
					ccFeeExemptStates: [],
				},
			});
		}
	},

	createDocuments: () => async (dispatch) => {
		console.log('[Invoices.redux] createDocuments')
		try {
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
				},
			});
			const response = await api.post('/create-documents/ar-invoice', {});
			console.log(response)
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
				},
			});
		}
	},
	loadInvoicePreview: (docEntry, objType) => async (dispatch) => {
		console.log('[invoices.redux] loadInvoicePreview  docEntry: ' + docEntry);
		dispatch(actions.setState({ pdfModalLoading: true }));
		try {
			const response = await api.get('/invoices/preview', {
				params: {
					docEntry,
					objType
				}
			});

			let fileData = response.FileData;
			let pdf = base64toPDF(fileData);

			dispatch(actions.setState({ pdfModalKey: docEntry }))
			dispatch(actions.setState({ pdfModalData: fileData }));
			dispatch(actions.setState({ pdfFilePreview: pdf }));
			dispatch(actions.setState({ pdfModalLoading: false }));
		} catch (e) {
			console.error(e);
			message.error('Could not load invoice preview');
			dispatch(actions.setState({ pdfModalLoading: false }));
		}
	},

	// getCustomerProfileIdFromSAP: (cardCode) => async (dispatch, getState) => {

	// 	//const state				= getState();
	// 	//const cardCodeFromState			= state.invoices.cardCode;

	// 	try {
	// 		const response = await api.get('/invoices/customer-profile-id', {
	// 			params: {
	// 				cardCode, // OR cardCodeFromState
	// 			}
	// 		});
	// 		console.log(response)
	// 		if (response.successful) {
	// 			console.log('Customer Profile id stored in SAP is: TODO ');
	// 		}

	// 	} catch (e) {
	// 		console.error(e);
	// 		message.error('Could not save Customer Profile id to Authorize.net.');

	// 	}
	// },

	recordCustomerProfileIdToSAP: (customerProfileId) => async (dispatch, getState) => {
		const state = getState(),
			cardCode = state.invoices.cardCode;

		try {
			const response = await api.post('/invoices/customer-profile-id', {
				params: {
					cardCode,
					customerProfileId,
				}
			});
			if (response.successful) {
				console.log('Customer Profile id ', customerProfileId, ' is Saved to SAP.');
			}

		} catch (e) {
			console.error(e);
			message.error('Could not save Customer Profile id to Authorize.net.');

		}
	},
	getAcceptToken_V3: (payType) => async (dispatch, getState) => {
		console.log('[Invoices.redux] getAcceptToken_V3');

		const state = getState(),
			cardCode = state.invoices.cardCode,
			cardName = state.invoices.cardName,
			storePayment = state.invoices.storePayment,
			invoicePaymentTotal = state.invoices.invoicePaymentTotal,
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum),
			customerProfileId_from_SAP = state.invoices.customerProfileId_from_SAP,
			cardPaymentFeesTotal = state.invoices.cardPaymentFeesTotal;

		//console.log('[Invoices.redux] getAcceptToken_V3  invoicePaymentTotal ', invoicePaymentTotal);
		//console.log('[Invoices.redux] getAcceptToken_V3  cardPaymentFeesTotal ', cardPaymentFeesTotal);

		let _customerEmail = Cookies.get('TS_email');
		console.log('_customerEmail ', _customerEmail);
		
		try {

			const _response = await api.get('/payments/get-accept-token', {
				params: {
					paymentType: payType,
					storePayment: storePayment,
					customerProfileId: customerProfileId_from_SAP,
					invoiceDocNums: invoiceDocNums,
					customerEmail: _customerEmail ?? "development@tiger-sheep.com", // TODO_EMAIL, will authorize consume this and do something with it while we also send customerProfileId?
					invoicePaymentTotal: invoicePaymentTotal,
					cardPaymentFeesTotal: cardPaymentFeesTotal,
					cardCode: cardCode,
					cardName: cardName
				}
			});
			//console.log(_response.response);
			//console.log(_response.response.token);
			if (_response.response.token) { // -OR- _response.response.messages.resultCode = 'Ok'
				console.log('[Invoices.redux] getAcceptToken_V3 successful');
				dispatch(actions.setState({
					acceptHostedToken: _response.response.token,
					cardPaymentFeesTotal: cardPaymentFeesTotal,
				}));
			} else {
				console.log('[Invoices.redux] getAcceptToken_V3 unsuccessful ELSE');
				dispatch(actions.setState({
					acceptHostedToken: null,
					currentPaymentState: paymentState.PRE_PAYMENT,
				}));
			}

		} catch (err) {
			console.error('[Invoices.redux] getAcceptToken_V3 catch err');
			console.error(err);
			message.error('Could not fetch Authorize.Net token');
			dispatch(actions.setState({
				acceptHostedToken: null,
			}));
		}
	},
	processPayment_V3: (authorizePaymentResponse) => async (dispatch, getState) => {
		console.log('[Invoices.redux] processPayment_V3');
		console.log(authorizePaymentResponse);

		const state = getState(),
			invoices = state.invoices.invoices,
			cardCode = state.invoices.cardCode,
			creditCardFees = state.invoices.cardPaymentFeesTotal,
			selectedInvoices = invoices.filter((invoice) => invoice.Checked),
			invoiceDocNums = selectedInvoices.map(invoice => invoice.DocNum),
			responseCode = state.invoices.responseCode;

		if (authorizePaymentResponse.responseCode !== '1') {
			console.error('[Invoices.redux] processPayment_V3 - Payment not authorized');
			return;
		}

		message.success('Your payment has processed successfully');

		dispatch(actions.setState({
			currentPaymentState: paymentState.PAID,
			responseCode: authorizePaymentResponse.responseCode,
			successfulTransactionId: authorizePaymentResponse.transId,
		}));

		let paymentResult;

		const isCreditCard = ['Visa', 'MasterCard', 'Mastercard', 'Discover', 'AmericanExpress'].includes(authorizePaymentResponse.accountType);

		try {
			paymentResult = await api.post('/invoices/payment-v3', {
				params: {
					transaction: authorizePaymentResponse,
					creditCardFees,
					invoiceDocNums,
					selectedInvoices,
					cardCode,
					calculateCCFees,
					isCreditCard
				}
			});

			if (paymentResult.successful) {
				console.log('Payment successfully recorded.');
				message.success('Your payment has been recorded');
				dispatch(actions.setState({
					currentPaymentState: paymentState.RECORDED,
					acceptHostedToken: null,
					successfulTransactionId: paymentResult.transactionId,
				}));
			} else {
				console.warn('Payment processed but failed to record in SAP.');
				message.error('Your payment was processed but there was an issue recording into SAP. It will be marked as Pending.');
				dispatch(actions.setState({
					currentPaymentState: paymentState.SAP_ERROR
				}));
			}
		} catch (paymentErr) {
			console.error('Unexpected error during payment recording:', paymentErr);
			const errorDetails = paymentErr.response?.data?.errors || paymentErr.message || 'Unknown error';
			console.error(errorDetails);

			// SAP errors are done in the backend

			dispatch(actions.setState({
				currentPaymentState: paymentState.SAP_ERROR
			}));
		}
	},

	showError_V3: (authorizePaymentResponse) => async (dispatch, getState) => {
		console.log('[Invoices.redux] showError_V3');
		console.log(authorizePaymentResponse);

		const state = getState(),
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum);

		// 1 -- Approved
		// 2 -- Declined
		// 3 -- Error
		// 4 -- Held for Review
		if (authorizePaymentResponse.responseCode == '2') {
			message.error('Your payment was declined');
		} else if (authorizePaymentResponse.responseCode == '3') {
			message.error('Your payment had an error');
		} else if (authorizePaymentResponse.responseCode == '4') {
			message.error('Your payment was held');
		}

		// NOTE the only reason were attempting to write to SAP here is because we could be getting error 4 -  held for review
		const errorDetails = ('Unknown Auth.net error responseCode: ' + authorizePaymentResponse.responseCode);

		// try {
		// 	const sapWriteFailLogResult = await api.post('/invoices/log-sap-failure', {
		// 		params: { invoiceDocNums, failedReasons: errorDetails }
		// 	});
		// 	console.log('Logged SAP error:', sapWriteFailLogResult);
		// } catch (logErr) {
		// 	console.error('Failed to log SAP error:', logErr);
		// }

		dispatch(actions.setState({
			currentPaymentState: paymentState.AUTH_ERROR
		}));

	},

};
